module.exports = __webpack_public_path__ + "static/media/gnpl.d6c93b3a.png";